
<div [id]="id" class="container" [ngClass]="{'invalid': invalid, 'disabled': disabled}">
  <div class="tags-container" (mouseup)="openClose($event)">
    <app-tags class="tag" [id]="id + '-' + i" [removable]="!disabled" (remove)="removeT(tag, i)" *ngFor="let tag of tags; let i = index">{{tag}}</app-tags>
  </div>
  
  <div class="open-btn" [id]="id + '-arrow'" (mouseup)="openClose($event)">
    <img src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen && !disabled}" label="arrow-icon" alt="dropdown-arrow">
  </div> 
  <div class="dropdown-box" *ngIf="isOpen && !disabled">
    <ng-content></ng-content>
  </div>
</div>
